'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formDataSelector = exports.filteredRestaurantsSelector = exports.bookingAvailabilitySelector = exports.pickerTimeSelector = exports.rushSlotsMapSelector = exports.rushSlotsForRestaurantSelector = exports.slotsAvailableSelector = exports.bookingRushResturantsSelector = exports.pickerSelectedSeatsIsPlus = exports.pickerSeatsSelector = exports.availableSpotsSelector = exports.maxPeopleSelector = exports.currentSlotSelector = exports.restaurantById = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _reselect = require('reselect');

var _location = require('../helpers/location');

var _location2 = _interopRequireDefault(_location);

var _restaurant = require('../helpers/restaurant');

var _restaurant2 = _interopRequireDefault(_restaurant);

var _time = require('../helpers/time');

var _time2 = _interopRequireDefault(_time);

var _voucher = require('../helpers/voucher');

var _voucher2 = _interopRequireDefault(_voucher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var BOOKING_PICKER_SEATS_PLUS = '+';

var restaurantById = exports.restaurantById = function restaurantById(restaurants, restaurantId) {
  return _lodash2.default.find(restaurants, { id: restaurantId });
};

var currentRestaurantSelector = function currentRestaurantSelector(state) {
  var restaurant = state.booking.targetRestaurant;
  if (restaurant) return restaurant.id;
  return null;
};

var currentSlotSelector = exports.currentSlotSelector = (0, _reselect.createSelector)(function (state) {
  return state.booking && state.booking.date;
}, function (state) {
  return state.booking.time;
}, function (date, time) {
  if (!date || !date.slots || !time) {
    return null;
  }
  return _lodash2.default.find(date.slots, { open: time });
});

var maxPeopleSelector = exports.maxPeopleSelector = (0, _reselect.createSelector)(function (state) {
  return state.booking.verifiedBookingRush;
}, function (state) {
  var bookingRush = state.app.bookingRush;

  return bookingRush && bookingRush.constraints.maxPeople;
}, function (state) {
  return state.app.config.booking.constraints.maxPeople;
}, function (hasBookingRushes, brMaxPeople, bMaxPeople) {
  return hasBookingRushes ? brMaxPeople : bMaxPeople;
});

var availableSpotsSelector = exports.availableSpotsSelector = (0, _reselect.createSelector)([currentSlotSelector, maxPeopleSelector], function (slot, maxPeople) {
  if (!slot) {
    return null;
  }
  return Math.min(maxPeople, slot.availableSpots);
});

var pickerSeatsSelector = exports.pickerSeatsSelector = (0, _reselect.createSelector)([availableSpotsSelector], function (availableSpots) {
  if (availableSpots === null) {
    return null;
  }
  var maxPlus = availableSpots + ' ' + BOOKING_PICKER_SEATS_PLUS;
  if (availableSpots === 1) {
    return [{ value: 1, label: 1 }];
  }
  var values = _lodash2.default.map(_lodash2.default.range(1, availableSpots + 1), function (n) {
    return {
      value: n,
      label: n
    };
  });
  return [].concat(_toConsumableArray(values), [{ value: maxPlus, label: maxPlus }]);
});

var pickerSelectedSeatsIsPlus = exports.pickerSelectedSeatsIsPlus = (0, _reselect.createSelector)(function (state) {
  return state.booking.seats;
}, function (seats) {
  if (!seats || typeof seats !== 'string') {
    return false;
  }
  return seats.indexOf(BOOKING_PICKER_SEATS_PLUS) > -1;
});

var bookingRushResturantsSelector = exports.bookingRushResturantsSelector = (0, _reselect.createSelector)(function (state) {
  return state.app.bookingRush;
}, function (bookingRush) {
  return bookingRush ? bookingRush.restaurants : [];
});

/* filter slots by seats availability */
var slotsAvailableSelector = exports.slotsAvailableSelector = (0, _reselect.createSelector)(function (state) {
  return state.booking && state.booking.date;
}, function (date) {
  if (!date || !date.slots) {
    return [];
  }
  return date.slots.filter(function (s) {
    return s.availableSpots > 0;
  });
});

var rushSlotsForRestaurantSelector = exports.rushSlotsForRestaurantSelector = (0, _reselect.createSelector)([bookingRushResturantsSelector, function (state) {
  if (!state.booking.targetRestaurant) {
    return null;
  }
  return state.booking.targetRestaurant.id;
}], function (restaurants, targetRestaurantId) {
  var restaurantData = _lodash2.default.find(restaurants, { restaurant: { id: targetRestaurantId } });
  if (!restaurantData) {
    return null;
  }
  return restaurantData.slots;
});

var rushSlotsMapSelector = exports.rushSlotsMapSelector = (0, _reselect.createSelector)([rushSlotsForRestaurantSelector], function (slotsForBookingRush) {
  return _lodash2.default.reduce(slotsForBookingRush, function (acc, x) {
    return _extends({}, acc, _defineProperty({}, x.open, true));
  }, {});
});

var pickerTimeSelector = exports.pickerTimeSelector = function pickerTimeSelector(localizedLabels) {
  return (0, _reselect.createSelector)([rushSlotsMapSelector, slotsAvailableSelector, function (state) {
    return state.booking ? state.booking.hasBookingRushes : false;
  }, function (state) {
    var bookingRush = state.app.bookingRush;
    return bookingRush ? _voucher2.default.format(bookingRush.voucher, localizedLabels).subtitle : '';
  }], function (rushSlotsMap, slotsAvailableSpots, hasBookingRushes, voucherMessage) {
    var slots = _lodash2.default.map(slotsAvailableSpots, function (s) {
      var extraInfo = hasBookingRushes && rushSlotsMap[s.open] ? '(' + voucherMessage + ')' : '';
      return {
        label: s.open + ' ' + extraInfo,
        value: s.open
      };
    });
    return slots;
  });
};

var bookingAvailabilitySelector = exports.bookingAvailabilitySelector = function bookingAvailabilitySelector(targetRestaurantSelector) {
  return (0, _reselect.createSelector)(function (state) {
    return state.app.merchant.restaurants;
  }, function (state) {
    return state.booking.availability;
  }, targetRestaurantSelector || currentRestaurantSelector, function (restaurants, availability, restaurantId) {
    if (!restaurantId) {
      return [];
    }

    var targetRestaurant = restaurantById(restaurants, restaurantId);

    var mapDays = _lodash2.default.reduce(targetRestaurant.openingTimes, function (acc, x) {
      return _extends({}, acc, _defineProperty({}, x.day, x.open));
    }, {});

    var target = _lodash2.default.find(availability, { id: restaurantId });

    if (!target) {
      return [];
    }

    var bookingAvailability = target.bookingAvailability;


    if (!bookingAvailability) {
      return [];
    }

    var filterByAvailableSpots = function filterByAvailableSpots(slot) {
      return slot.availableSpots > 0;
    };

    return _lodash2.default.map(bookingAvailability, function (availabilityDay) {
      return _extends({}, availabilityDay, {
        open: mapDays[availabilityDay.day],
        hasAvailableSpots: _lodash2.default.some(availabilityDay.slots, filterByAvailableSpots)
      });
    });
  });
};

var filteredRestaurantsSelector = exports.filteredRestaurantsSelector = (0, _reselect.createSelector)(function (state) {
  return state.app.merchant.restaurants;
}, function (state) {
  return state.booking.userLocation;
}, function (state) {
  return state.app.bookingRush;
}, function (restaurants, userLocation, bookingRush) {
  var data = _lodash2.default.map(restaurants, function (r) {
    var hasBookingRushes = bookingRush && !_time2.default.isDateExpired(bookingRush.expirationDate) && _lodash2.default.filter(bookingRush.restaurants, { restaurant: { id: r.id } }).length > 0;
    return _extends({}, r, {
      hasBookingRushes: hasBookingRushes,
      availableForBooking: _restaurant2.default.hasOnlineService(r, 'booking'),
      distance: userLocation ? _location2.default.distanceBetweenPoints(userLocation, {
        lat: r.location.latitude,
        lng: r.location.longitude }) : null
    });
  });
  var cmpKey = userLocation ? 'distance' : 'address';
  return data.sort(function (r1, r2) {
    return r1[cmpKey] > r2[cmpKey];
  });
});

var formDataSelector = exports.formDataSelector = (0, _reselect.createSelector)(function (state) {
  return state.booking.formData;
}, function (state) {
  return state.user.currentUser;
}, function (formData) {
  var user = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return _extends({}, _lodash2.default.pick(user, ['name', 'lastName', 'email']), formData);
});


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/lib/selectors/booking.js
// module id = 87
// module chunks = 0